module.exports = __webpack_public_path__ + "img/Sweden.6f4686c7.jpg";